import { render } from "./TicketGet.vue?vue&type=template&id=f2419e48&ts=true"
import script from "./TicketGet.vue?vue&type=script&lang=ts"
export * from "./TicketGet.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__